import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import routes from "router/routes";
import { makeStyles } from "@material-ui/core/styles";

import { useSelector } from "react-redux";

import UserNavBar from "components/Navbars/UserNavBar";
import './index.scss';

import { getAuthInfo, isLoggedIn } from "store/slices/auth";
import UserSidebar from "components/Sidebar/UserSidebar";
import { useTranslation } from "react-i18next";
import styles from "assets/jss/material-dashboard-react/layouts/userStyle.js";
import { Helmet } from "react-helmet";
import AppUtil from "../utilities/AppUtil";
import AppConfig, { SYSTEM_ROLE, CLIENT_TYPE } from "config/AppConfig";
import AppColor from "utilities/AppColor";
import classNames from "classnames";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Typography } from "@material-ui/core";
import moment from "moment";

const { APPROVAL_STATUS } = AppConfig;

const useStyles = makeStyles((theme) => ({
  ...styles(theme),
  adminContent: {
    padding: '1.5rem',
    margin: '20px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '21px'
  },
  titleContainer: {
    margin: '20px 20px 0',
  },
  title: {
    fontSize: '30px',
    fontWeight: 'bold',
    color: AppColor.mainColor
  },
  console: {
    height: '100vh',
    paddingTop: 50,
    display: "flex"
  }
}));

const User = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const loggedIn = useSelector(isLoggedIn) || false;
  const authInfo = useSelector(getAuthInfo) || {};

  const [mobileOpen, setMobileOpen] = useState(true);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [companySubscription, setCompanySubscription] = useState({
    name: "",
    expiredDate: "",
  });
  const [isExpired, setExpired] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        authInfo &&
        authInfo.companySubcriptionExpiryDate &&
        authInfo.companySubscriptionName
      ) {
        const _expiredDate = moment(authInfo.companySubcriptionExpiryDate);
        const currentDate = moment();
        // console.log('check', _expiredDate.diff(currentDate));
        if (_expiredDate.diff(currentDate) > 0) {
          setExpired(false);
        } else {
          setExpired(true);
          clearInterval(interval);
        }
      }
    }, 100);
    if (
      authInfo &&
      authInfo.companySubcriptionExpiryDate &&
      authInfo.companySubscriptionName
    ) {
      setCompanySubscription({
        name: authInfo.companySubscriptionName,
        expiredDate: authInfo.companySubcriptionExpiryDate,
      });
    }
  }, [authInfo]);

  useEffect(() => {
    if (!loggedIn) {
      return;
    } else {
      if (authInfo.role === SYSTEM_ROLE.SUPER_ADMIN ||
        authInfo.role === SYSTEM_ROLE.MANAGER || authInfo.role === SYSTEM_ROLE.COMPANY) {
          history.push("/admin/profile");
      }
      if ((authInfo.approvalStatus === APPROVAL_STATUS.PENDING ||
        authInfo.approvalStatus === APPROVAL_STATUS.REJECT) && authInfo.role !== SYSTEM_ROLE.COMPANY) {
        history.push("/profile");
      }
      if((authInfo.clientType === CLIENT_TYPE.SINGLE_USER_HOSPITAL || authInfo.clientType === CLIENT_TYPE.SINGLE_USER_COORDINATOR) && history.location.pathname.includes('users')) {
        history.push('/dashboard');
      } 
    }
  }, [authInfo, loggedIn]);

  const resizeFunction = () => {
    if (window.innerWidth < 600) {
      setMobileOpen(false);
    } else {
      setMobileOpen(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", resizeFunction);
    return () => {
      window.removeEventListener("resize", resizeFunction);
    };

  }, []);

  const menuFilter = (e) => {
    if (e.accessRole === '*') {
      return e.layout === '/';
    }
    if (e.accessRole && e.accessClient) {
      return e.layout === '/'
        && e.accessRole && e.accessRole.includes(authInfo.role) && e.accessClient && e.accessClient.includes(authInfo.clientType);
    } else if (e.accessRole && !e.accessClient) {
      return e.layout === '/'
        && e.accessRole && e.accessRole.includes(authInfo.role)
    } else {
      return e.layout === '/';
    }
  }

  useEffect(() => {
    routes.filter(e => {
      if ((authInfo.role === SYSTEM_ROLE.HOSPITAL_ADMIN || authInfo.role === SYSTEM_ROLE.COORDINATOR_ADMIN)) {
        if (authInfo.clientType === CLIENT_TYPE.SINGLE_USER_HOSPITAL || authInfo.clientType === CLIENT_TYPE.SINGLE_USER_COORDINATOR) {
          return e.layout 
        }
      }
    })
  }, []);

  const switchRoutes = (
    <Switch>
    {routes.filter(menuFilter).map((route, key) => {
      if (route.layout === "/") {
        return <Route
          path={route.path}
          component={(props) => (
            <React.Fragment>
                <Typography
                  style={{ color: isExpired ? AppColor.red : AppColor.orange, marginTop: '10px' }}
                  align="center"
                >
                  {isExpired && (authInfo.role !== "NURSE" && authInfo.role !== "SUPPORT_WORKER")
                    ? `${t(
                        "text.expired_date_subscription"
                      )}
                      ${companySubscription.name}
                      ${t("text.expired_date_subscription_2")}
                      ${AppUtil.formatDate(
                        companySubscription.expiredDate,
                        "MM/DD/YYYY HH:mm:ss"
                      )}${t("text.expired_date_subscription_3")}`
                    : ''}
                </Typography>
              <div className={classes.titleContainer}>
                <h3 className={classes.title}>{t(route.extraTitle ? route.extraTitle : route.name)}</h3>
              </div>
              <div className={`${classes.adminContent}`}>
                <route.component {...props} />
              </div>
            </React.Fragment>
          )}
          key={key}
          exact
        />;
      }
      return null;
    })}
    <Redirect from="/" to="/dashboard" />
  </Switch>
  );
  return (
    <PerfectScrollbar
      className={classNames({
        "user-console": true,
        [classes.console]: true
      })}
      options={{
        suppressScrollX: true,
        suppressScrollY: false
      }}
      id="main-panel"
    >
      <Helmet>
        <title>{AppUtil.makeBrand(routes)}</title>
      </Helmet>
      <UserNavBar
        userInfo={authInfo}
        routes={routes}
        handleDrawerToggle={handleDrawerToggle}
      />
      <Box display="flex" width="100%">
        <UserSidebar
          routes={routes.filter(item => item.layout === '/')}
          logoText={t("app.name")}
          handleDrawerToggle={handleDrawerToggle}
          open={mobileOpen}
          color="violet"
        />
        <Box flex="1 auto" overflow="hidden" height="fit-content">
          <div
            className={classNames({
              [classes.mainPanel]: true
            })}
          >
            {switchRoutes}
            {/* <Switch>
              {routes.map((route, key) => {
                if (route.layout === "/") {
                  return <Route
                    path={route.path}
                    component={(props) => (
                      <React.Fragment>
                        <div className={classes.titleContainer}>
                          <h3 className={classes.title}>{t(route.extraTitle ? route.extraTitle : route.name)}</h3>
                        </div>
                        <div className={`${classes.adminContent}`}>
                          <route.component {...props} />
                        </div>
                      </React.Fragment>
                    )}
                    key={key}
                    exact
                  />;
                }
                return null;
              })}
              <Redirect from="/" to="/dashboard" />
            </Switch> */}
          </div>
        </Box>
      </Box>
    </PerfectScrollbar>
  );
}

export default User;
